export const iconFontAwesomeCodingFireExtinguisher = (
	<i className="fa-solid fa-fire-extinguisher"></i>
);
